module.exports = __webpack_public_path__ + "img/body-background-le-murmure-des-attentes.c53ef776.png";